import { getUrlParam, objToQueryStr } from '@futuweb/tool-base';

let isLogin = false;
let toLogin;

if (window.FEGORender) {
    const {
        common,
        store: { variable }
    } = window.FEGORender;

    // 是否已登录
    isLogin = Boolean(variable.data.UID);
    // 去登录
    toLogin = () => {
        let global_content = '';
        try {
            const tmp_global_content = JSON.parse(getUrlParam('global_content'));
            // 删除invite参数
            delete tmp_global_content.invite;
            global_content = JSON.stringify(tmp_global_content);
        } catch (err) {
            console.log('global_content解析失败');
            global_content = JSON.stringify({});
        }
        const indexUrl = window.location.href.split('#')[0];
        const query = {
            target: indexUrl,
            regbtntxt: 4,
            // hidetab: 1,
            // hidethird: 1, // 隐藏第三方登录
            autoJump: true,
            region: '852',
            type: 'reg',
            lang: 'zh-hk',
            global_content
        };
        const loginUrl = `https://passport.futunn.com?${objToQueryStr(query)}`;
        location.href = loginUrl;
    };
}

function getEntity() {
    // 获取插件配置
    return window._extra['tool-date-formatter']?.options?.entity;
}

export { getEntity, isLogin, toLogin };
